/* eslint-disable */
import React, { memo, useState, useEffect } from "react";

import * as Styles from "./styles";
import { CardOportunidades } from "./components/OportunidadeSection";
import { ResponsaveisSection } from "./components/ResponsaveisSection";
import TarefaSection from "./components/TarefasSection";
// import TarefasSectionV2 from "./components/TarefasSectionV2";

interface Props {
  idLead: string | undefined;
  avoidRefetch: boolean;
  idLeadCorretor: string | undefined;
  idCorretorLead: string | undefined;
  onOpenNewTask: () => void;
  onOpenEditTask: (val: any) => void;
  onOpenConcludeTask: (val: any) => void;
  onOpenShare: () => void;
  dataLead: any;
  refetchDataLead: () => void;
  readOnly?: boolean;
}

function TabSection(props: Props) {
  // Busca o objeto salvo no localStorage, se existir
  const storedData = localStorage.getItem("leadTabData");
  const parsedData = storedData ? JSON.parse(storedData) : null;

  // Define o valor inicial da tab
  // Se o idLead atual for o mesmo do localStorage, pega a tabValue salvo;
  // caso contrário, default 0 (tarefas).
  const [tabValue, setTabValue] = useState<number>(() => {
    if (parsedData && parsedData.idLeadCorretor === props.idLeadCorretor) {
      return parsedData.tabValue ?? 0;
    }
    return 0;
  });

  // useEffect para monitorar mudanças no idLead:
  // se mudar e for diferente do que está salvo, definimos tab=0 e atualizamos localStorage
  useEffect(() => {
    if (props.idLeadCorretor) {
      if (!parsedData || parsedData.idLeadCorretor !== props.idLeadCorretor) {
        const newData = { idLeadCorretor: props.idLeadCorretor, tabValue: 0 };
        localStorage.setItem("leadTabData", JSON.stringify(newData));
        setTabValue(0);
      }
    }
  }, [props.idLeadCorretor]);

  // Ao mudar de tab, salvamos no localStorage o novo tabValue
  const handleChangeTab = (event: any, newValue: number) => {
    setTabValue(newValue);

    // Monta objeto atualizado
    const newData = {
      idLeadCorretor: props.idLeadCorretor,
      tabValue: newValue,
    };

    // Salva no localStorage
    localStorage.setItem("leadTabData", JSON.stringify(newData));
  };

  // TabPanel para renderização condicional
  function TabPanel({ children, value, index, ...other }: any) {
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <>{children}</>}
      </div>
    );
  }

  function thisProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  return (
    <Styles.Container>
      <Styles.Box>
        <Styles.Tabs
          indicatorColor="secondary"
          value={tabValue}
          onChange={handleChangeTab}
          aria-label="basic tabs example"
        >
          <Styles.Tab label="TAREFAS" {...thisProps(0)} />
          <Styles.Tab label="PROPOSTAS" {...thisProps(1)} />
          <Styles.Tab label="RESPONSÁVEIS" {...thisProps(2)} />
        </Styles.Tabs>
      </Styles.Box>
      <TabPanel value={tabValue} index={0}>
        <Styles.RowIndicators>
          <TarefaSection
            accordionOpen={tabValue === 0}
            idLead={props.idLead}
            onChange={() => console.log(true)}
            onOpenNewTask={() => props.onOpenNewTask()}
            avoidRefetch={props.avoidRefetch}
            onOpenEditTask={(val: any) => props.onOpenEditTask(val)}
            onOpenConcludeTask={(val: any) => props.onOpenConcludeTask(val)}
            dataLead={props?.dataLead}
            refetchDataLead={() => props.refetchDataLead()}
          />
          {/* <TarefasSectionV2
            idLead={props.idLead}
            onOpenNewTask={() => props.onOpenNewTask()}
            onOpenEditTask={(val: any) => props.onOpenEditTask(val)}
            onOpenConcludeTask={(val: any) => props.onOpenConcludeTask(val)}
            dataLead={props?.dataLead}
          /> */}
        </Styles.RowIndicators>
      </TabPanel>
      <TabPanel value={tabValue} index={1}>
        <Styles.RowIndicators>
          <CardOportunidades
            accordionOpen
            idLead={props.idLead}
            dataLead={props.dataLead}
            isOpen
            onChange={() => console.log(true)}
            readOnly={props.readOnly}
          />
        </Styles.RowIndicators>
      </TabPanel>
      <TabPanel value={tabValue} index={2}>
        <Styles.RowIndicators>
          <ResponsaveisSection
            tabValue={tabValue}
            idLeadCorretor={props.idLeadCorretor}
            idLead={props.idLead}
            idCorretorLead={props.idCorretorLead}
            onOpenShare={() => props?.onOpenShare()}
            isOrigemCyrela={props.dataLead.origemLead === "Mídia Cyrela"}
          />
        </Styles.RowIndicators>
      </TabPanel>
    </Styles.Container>
  );
}

export default memo(TabSection);
